<script lang="ts">
export default {
  name: 'KkApprovalSummaryItem',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export interface Props {
  type: string
  isActive?: boolean
  count?: number
  title?: string
}

export interface Emits {
  (key: 'click', event: MouseEvent): void
}

const { t } = useI18n()
const props = withDefaults(defineProps<Props>(), {
  count: 0,
})

const emits = defineEmits<Emits>()
const onClick = (event: MouseEvent) => {
  emits('click', event)
}

const title = computed(() => {
  return props.title ?? t(`models.approvalStatus.${props.type}`)
})
</script>

<template>
  <div class="item" :class="{ 'isActive': props.isActive }">
    <span class="title">{{ title }}:</span>
    <div class="summary">
      <button type="button" @click="onClick($event)">{{ props.count }}</button>{{ t('models.approvalStatus.unit') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  width: 200px;
  height: 65px;
  border-radius: 4px;
  background-color: #ECEDF0;
  font-weight: bold;
  font-size: 10px;
  &.isActive {
    background-color: #F8F9FA;
  }
  .title {
    margin: 8px 0;
    text-align: center;
  }
  .summary {
    margin-bottom: 8px;
    text-align: center;
    button {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      text-decoration-line: underline;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
